export default {
    pluginName: 'paper',
    backendDataType: 'PAPER',
    rowIdKey: 'DOC_ID',
    edit: 'data_edit',
    count: 'paper_count',
    totalCount: 'total_paper_count',
    fieldI18nKey: 'commonPaper',
    maxPerFolder: 'max_paper_per_folder',
    maxOp: 'max_op_paper',
    staticFields: ['TITLE'],
    dataId: 'PAPER_ID',
};
